module.exports = __webpack_public_path__ + "img/gameTronos13.e8df0698.jpg";